import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';
import MiniPriceSimulator from '../../components/feature/MiniPriceSimulator';

export default function TransportParisPage() {
  useEffect(() => {
    document.title = "Transport Paris | Transporteur Express IDF - Coursier, Utilitaire avec Chauffeur, Aide Déménagement";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transporteur Express IDF à Paris : coursier express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement, transport marchandises 24/7. Devis gratuit !');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'transport Paris, transporteur express Paris, coursier Paris, location camion Paris, utilitaire avec chauffeur Paris, aide au déménagement Paris, aide au chargement Paris, transport marchandises Paris, livraison urgente Paris, déménageur Paris, porteur déménagement, manutentionnaire Paris, camion déménagement Paris, transport colis Paris, fret routier Paris, logistique B2B Paris');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://transporteurexpressidf.fr/transport-paris');
    }
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Transport Paris | Transporteur Express IDF - Coursier, Utilitaire avec Chauffeur, Aide Déménagement');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Transporteur Express IDF à Paris : coursier express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement, transport marchandises 24/7.');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', 'https://transporteurexpressidf.fr/transport-paris');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="transport" />
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-gray-50 to-gray-100 py-20 pb-16">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-5xl font-black text-gray-900 mb-6 font-inter">
                Solutions de transport routier et logistique pour les pros
              </h1>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                <strong>Transport de marchandises Paris</strong> professionnel pour entreprises. Notre service de <strong>fret routier</strong> et <strong>logistique dernier kilomètre</strong> optimise votre supply chain. <strong>Transporteur Express IDF</strong> : votre partenaire B2B de confiance disponible 24h/24 et 7j/7.
              </p>
              <div className="mt-8 text-sm text-gray-500">
                <p>Découvrez aussi nos services locaux : <a href="/transporteur-express-nanterre" className="text-red-600 hover:underline">Nanterre</a>, <a href="/transporteur-palettes-rungis" className="text-red-600 hover:underline">Rungis</a>, <a href="/livraison-urgente-evenementiel-villepinte" className="text-red-600 hover:underline">Villepinte</a></p>
              </div>
            </div>
            
            <div className="text-center">
              <a 
                href="tel:+33632410246"
                className="inline-flex items-center px-8 py-4 bg-red-600 text-white text-lg font-semibold rounded-full hover:bg-red-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line w-5 h-5 mr-3"></i>
                Devis Gratuit +33 6 32 41 02 46
              </a>
            </div>
          </div>
        </section>

        {/* Mini Price Simulator */}
        <MiniPriceSimulator />

        {/* Services de Transport */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Services de Transport Paris
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-truck-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Transport Express Paris</h3>
                <p className="text-gray-600 mb-4">
                  Transport express dans Paris en moins de 2 heures. Service transport urgent pour vos colis prioritaires dans tout Paris et banlieue.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Transport Paris centre en 30 min</li>
                  <li>• Transport Paris banlieue en 1-2h</li>
                  <li>• Transport urgent 24/7</li>
                  <li>• Suivi en temps réel</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-home-4-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Déménagement Paris</h3>
                <p className="text-gray-600 mb-4">
                  Service déménagement Paris professionnel. Transport déménagement avec utilitaires et équipe experte pour déménagement appartement et bureau.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Déménagement Paris rapide</li>
                  <li>• Transport volumineux</li>
                  <li>• Équipe professionnelle</li>
                  <li>• Déménagement bureau</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-time-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Transport Urgent 24/7</h3>
                <p className="text-gray-600 mb-4">
                  Transport urgent Paris disponible jour et nuit. Service transport express pour vos livraisons prioritaires et courses urgentes.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Transport Paris nuit</li>
                  <li>• Transport weekend</li>
                  <li>• Transport jours fériés</li>
                  <li>• Intervention immédiate</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-building-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Transport Professionnel</h3>
                <p className="text-gray-600 mb-4">
                  Transport professionnel Paris pour entreprises. Coursier professionnel, transport documents, livraison entreprise avec facture.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Transport entreprise</li>
                  <li>• Coursier bureau</li>
                  <li>• Transport documents</li>
                  <li>• Facture professionnelle</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-e-bike-2-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Coursier Moto Paris</h3>
                <p className="text-gray-600 mb-4">
                  Coursier moto Paris ultra rapide. Livraison moto dans Paris intramuros en 30 minutes maximum. Transport moto écologique et efficace.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Coursier moto rapide</li>
                  <li>• Livraison Paris 30 min</li>
                  <li>• Transport écologique</li>
                  <li>• Évite les embouteillages</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-car-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Transport Utilitaire</h3>
                <p className="text-gray-600 mb-4">
                  Transport utilitaire Paris pour gros volumes. Camionnette transport, utilitaire déménagement, transport volumineux avec chauffeur.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Utilitaire transport</li>
                  <li>• Transport gros colis</li>
                  <li>• Camionnette équipée</li>
                  <li>• Chauffeur professionnel</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Zones de Transport */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Zones de Transport Paris
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Paris Centre</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Transport Paris 1er</li>
                  <li>• Transport Paris 2ème</li>
                  <li>• Transport Paris 3ème</li>
                  <li>• Transport Paris 4ème</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Paris Nord</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Transport Paris 17ème</li>
                  <li>• Transport Paris 18ème</li>
                  <li>• Transport Paris 19ème</li>
                  <li>• Transport Paris 20ème</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Paris Sud</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Transport Paris 13ème</li>
                  <li>• Transport Paris 14ème</li>
                  <li>• Transport Paris 15ème</li>
                  <li>• Transport Montparnasse</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Île-de-France</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Transport Boulogne</li>
                  <li>• Transport Neuilly</li>
                  <li>• Transport Vincennes</li>
                  <li>• Transport La Défense</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Transport Paris */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Questions Fréquentes Transport Paris
            </h2>
            
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Combien coûte un transport Paris ?</h3>
                <p className="text-gray-600">
                  Le prix transport Paris varie selon la distance et l'urgence. Transport Paris centre dès 15€, transport Paris banlieue dès 25€. Devis transport gratuit par téléphone.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Quel délai pour un transport urgent Paris ?</h3>
                <p className="text-gray-600">
                  Transport urgent Paris en 30 minutes maximum dans Paris intramuros. Transport express Paris banlieue en 1-2 heures selon la destination.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Faites-vous du déménagement Paris ?</h3>
                <p className="text-gray-600">
                  Oui, nous proposons un service déménagement Paris complet avec utilitaire, équipe professionnelle et transport volumineux pour appartement et bureau.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Le transport Paris est-il disponible la nuit ?</h3>
                <p className="text-gray-600">
                  Absolument ! Notre service transport Paris fonctionne 24h/24 et 7j/7, y compris transport nuit, weekend et jours fériés.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Final */}
        <section className="py-20 bg-red-600 text-white">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">
              Besoin d'un Transport Paris Maintenant ?
            </h2>
            <p className="text-xl mb-8 opacity-90">
              Transport express, déménagement, coursier urgent - Appelez-nous !
            </p>
            <a 
              href="tel:+33632410246"
              className="inline-flex items-center px-8 py-4 bg-white text-red-600 text-lg font-semibold rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line w-5 h-5 mr-3"></i>
              +33 6 32 41 02 46
            </a>
          </div>
        </section>
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
}